// this file is generated by update_shopify_store_data.py at 2026-03-18 20:34:26.015483
var courses = [
    {
        "course_id": "235E6FE9-27BB-F011-99A0-005056A78EAA",
        "course_version": 1,
        "name": "Foundational Communication: Guiding People Through Health-Related Behavior Change",
        "course_type": 1,
        "author_information": "Annie Youngblood, NBC-HWC",
        "description": "This e-learning\u00a0introduces a powerful, evidence-based approach to communication grounded in trust, curiosity, and partnership. You\u2019ll learn how to build collaborative relationships, apply core skills from Motivational Interviewing, and engage patients in conversations that support change. Whether you're working in behavioral health, primary care, or community outreach, these skills help create more meaningful, effective interactions.",
        "learning_objectives_html": "This module introduces providers to a collaborative approach in patient and client care, emphasizing partnership, mutual respect, and shared decision-making. The goal is to move beyond traditional hierarchies and objectives, focusing instead on building relationships that empower patients and encourage active participation in their own healthcare processes.<br />\r\n<br />\r\nBy the end of this module, you should be able to:\r\n<ol>Define the differences in a directive and prescriptive approach vs. a collaborative, patient-empowered approach to care\r\n</ol>\r\n<ol>List some of the key skills that support a patient-first approach\r\n</ol>\r\n<ol>Understand the basic characteristics of growth-fostering relationships and how they impact your ability to provide effective support\r\n</ol>\r\n<ol>Describe the research on relationship variables and psychotherapy outcomes\r\n</ol>\r\n<ol>Characterize the evidence-supported relationship factors that create a strong relationship\r\n</ol>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "7250EEC8-F7D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Foundational Communication: Guiding People Through Health-Related Behavior Change",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5936B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Behavioral Health Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Leadership Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "222C7486-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Interpersonal Relationships",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5CF89115-F6D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing: Foundational Communication: Guiding People Through Health-Related Behavior Change",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 4 contact hours to participants who complete all sections and and the course survey.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 4.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];